(function(angular){
	'use strict';
	
	var iconObject = {
		bindings: {
			iconType: '<'
		},
		controller: [
			'$element',
			'IconService',
			IconFunction
		],
		controllerAs: 'icon'
	};
	
	angular
		.module('iconModule')
		.component('icon', iconObject);
	
	function IconFunction($element, IconService){
		var icon = this;

		icon.$onChanges = function(changeObj) {
			var iconType = changeObj.iconType.currentValue;
			IconService.getIconTemplate(iconType).then(function(template) {
				$element[0].innerHTML = template;
			});
		};
	}
})(window.angular);